// Reframe before starting motion, including clicks made after scrolling a long form.
// Instant scrolling prevents the animation from finishing during a smooth scroll.
export function revealInteraction(scene){
 if(!scene)return;
 if(document.activeElement?.matches('input,textarea'))document.activeElement.blur();
 scene.scrollIntoView({block:'center',inline:'nearest',behavior:'instant'});
 const main=document.querySelector('main'),vv=window.visualViewport;
 function frame(){
  if(!scene.closest('.screen.active'))return;
  const container=main.getBoundingClientRect(),rect=scene.getBoundingClientRect();
  const top=Math.max(container.top,vv?.offsetTop||0),bottom=Math.min(container.bottom,(vv?.offsetTop||0)+(vv?.height||innerHeight));
  if(rect.top<top||rect.bottom>bottom)main.scrollBy({top:(rect.top+rect.bottom-top-bottom)/2,behavior:'instant'});
 }
 frame();
 // Mobile keyboards can finish closing after the click. Keep feedback in frame
 // during that resize only; never keep scrolling after the interaction has ended.
 vv?.addEventListener('resize',frame);
 setTimeout(()=>vv?.removeEventListener('resize',frame),1300);
}
